/* eslint-disable */
import Persister from "../../../utils/LocalStoragePersister";

const mutations = {
  setFilter(state, value) {
    state.filter = value;
  }
};

export default mutations;
